import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { mypayslip } from "../../../services/admin";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";

export default function MyPayslip() {
    const [filterProduct, setFilterProduct] = useState([]);
    const navigate = useNavigate();

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 140,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a onClick={() => navigate(`/payslip/payslipreport/${params.value}`)}
                            className="btn-sm btn-primary me-2"
                            title="View / Download Payslip"
                        >
                            <i className="fa fa-download"></i>
                        </a>
                    </div>
                );
            },
        },
        {
            headerName: "Month",
            field: "month",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Year",
            field: "year",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Pay Date",
            field: "pay_date",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            }
        },
        {
            headerName: "Gross",
            field: "gross_salary",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Total Deduction",
            field: "total_deduction",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Net Salary",
            field: "net_salary",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
        },
    ];

    useEffect(() => {
        funlist();
    }, []);

    function funlist() {
        setFilterProduct([]);
        mypayslip().then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data.details);
            }
        });
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">My Payslips</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Payslip</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        My Payslips
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    My Payslip Detail
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={filterProduct}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
